var map = {
	"./about-us.png": 9390,
	"./about-vegetables.png": 5864,
	"./app-download-img-left.png": 4284,
	"./app-download-img.png": 3738,
	"./app-store.svg": 8421,
	"./categoryCard1.jpg": 9554,
	"./categoryCard2.jpg": 8167,
	"./categoryCard3.jpg": 6071,
	"./contact-us.png": 1210,
	"./delivery-boy.png": 1909,
	"./ins3.png": 1183,
	"./ins4.png": 1301,
	"./logo-color.svg": 122,
	"./men-1.png": 2345,
	"./men-2.png": 1879,
	"./men-3.png": 934,
	"./no-result.svg": 1146,
	"./page-header-bg.jpg": 3737,
	"./payment-logo.png": 4538,
	"./play-store.svg": 5278,
	"./product-278.png": 5946,
	"./product-279.png": 7852,
	"./product-280.png": 413,
	"./product-281.png": 9661,
	"./product-282.png": 2943,
	"./product-283.png": 6086,
	"./slider-1.png": 7037,
	"./slider-2.png": 2955,
	"./slider-3.png": 7380,
	"./verifiedemail.jpeg": 9265,
	"./women-1.png": 5550,
	"./women-2.png": 7945,
	"./women-3.png": 334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1600;